import { render } from "./RightDeals.vue?vue&type=template&id=4491aae0&scoped=true"
import script from "./RightDeals.vue?vue&type=script&lang=js"
export * from "./RightDeals.vue?vue&type=script&lang=js"

import "./RightDeals.vue?vue&type=style&index=0&id=4491aae0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4491aae0"]])

export default __exports__